<script lang="ts" setup>
import { useRoute } from "#app";
import H1Heading from "~/components/H1Heading.vue";
import CredentialLogos from "~/components/home/CredentialLogos.vue";
import RecentlyViewed from "~/components/home/RecentlyViewed.vue";
import SalesTeam from "~/components/home/SalesTeam.vue";
import SearchProducts from "~/components/product/SearchProducts.vue";

//Data
const route = useRoute();

const arySlug = route.params.slug;
let state = "";
let page = "1";
if (arySlug.length >= 2 && arySlug[0].toLowerCase() == "state") {
    state = arySlug[1].toUpperCase();
    if (arySlug.length >= 4 && arySlug[2].toLowerCase() == "page") {
        page = arySlug[3];
    }
} else if (arySlug.length >= 2 && arySlug[0].toLowerCase() == "page") {
    page = arySlug[1];
}

const sortBy = ref("");
const limit = ref("20");
if (route.query) {
    for (const [key, value] of Object.entries(route.query)) {
        if (key === "sortBy") {
            sortBy.value = String(value);
        } else if (key === "limit") {
            limit.value = String(value);
        }
    }
}
</script>

<template>
    <div>
        <H1Heading
            size="text-3xl md:text-4xl"
            class="relative"
        >
            Shop All</H1Heading
        >
        <div class="mb-6 pt-4 text-center text-base font-medium md:pt-0 md:text-xl xl:text-3xl">
            Need to download a quote? Add items to your cart to begin.
        </div>

        <SearchProducts
            :page="page"
            :sort-by="sortBy"
            :limit="limit"
            class="mb-20"
        />

        <RecentlyViewed />
        <hr class="my-10" />
        <CredentialLogos />
        <hr class="my-10" />
        <SalesTeam :state="state" />
    </div>
</template>

<style scoped></style>
